angular.module("avant.customer_applications.directives").directive "ukPostcode", ["$parse", "$http", "ConfigService", "ApplicationService", ($parse, $http, ConfigService, ApplicationService) ->

  require: 'ngModel',

  scope: {},

  controller: [
    "$scope", "$attrs", "$modal", "$log", ($scope, $attrs, $modal, $log) ->

      $scope.$parent["#{$attrs.ukPostcode}_visible"] = false

      $scope.$parent.$watch $attrs.ngModel, (newValue, oldValue) ->
        return if !newValue and !oldValue # Ignore first-run values since we've already defaulted the element state.
        $scope.$parent["#{$attrs.ukPostcode}_visible"] = true if newValue
        capitalValue = newValue && newValue.toUpperCase()
        model = $parse($attrs.ngModel)
        model.assign($scope.$parent, capitalValue) if capitalValue

      $scope.open = ->
        modalInstance = $modal.open(
          templateUrl: "/shared/v3/modals/uk_postcode.html"
          controller: [
              "$scope", "$modalInstance", "addresses", ($scope, $modalInstance, addresses) ->
                $scope.addresses = addresses
                $scope.select = (address) ->
                  $modalInstance.close address
                $scope.cancel = ->
                  $modalInstance.dismiss "cancel"
            ]
          resolve:
            addresses: ->
              $scope.addresses
        )
        modalInstance.result.then ((selectedAddress) ->
          $scope.fetchAddress selectedAddress
        ), ->
          $scope.throwError($attrs.ukPostcodeErrorOther)

      $scope.fetchAddress = (selectedAddress) ->
        $http
          .post("#{ConfigService.apiBaseUrl(ApplicationService.target_application_id())}/uk_postcode", address_id: selectedAddress.id)
          .then(
            (response) ->
              { data } = response
              if data?[0]?.error_number? or (data && data.length is 0)
                $scope.clearFields()
                $scope.throwError($attrs.ukPostcodeErrorOther)
              else
                $scope.applyAddress data
              response
            , -> $scope.throwError($attrs.ukPostcodeErrorOther)
        )

      $scope.applyAddress = (data) ->
        $parse($attrs.ukPostcodeAddress1).assign($scope.$parent, data[0].street)
        $parse($attrs.ukPostcodeAddress2).assign($scope.$parent, data[0].flat_number)
        $parse($attrs.ukPostcodeHouseName).assign($scope.$parent, data[0].house_name)
        $parse($attrs.ukPostcodeHouseNumber).assign($scope.$parent, data[0].house_number)
        $parse($attrs.ukPostcodePostTown).assign($scope.$parent, data[0].post_town)
        $scope.updateAllFields()
        $scope.$parent["#{$attrs.ukPostcode}_message"] = null
        $scope.$parent["#{$attrs.ukPostcode}_visible"] = true

      $scope.clearFields = ->
        $parse($attrs.ukPostcodeAddress1).assign($scope.$parent, "")
        $parse($attrs.ukPostcodeAddress2).assign($scope.$parent, "")
        $parse($attrs.ukPostcodeHouseName).assign($scope.$parent, "")
        $parse($attrs.ukPostcodeHouseNumber).assign($scope.$parent, "")
        $parse($attrs.ukPostcodePostTown).assign($scope.$parent, "")
        $scope.updateAllFields()

      $scope.updateAllFields = ->
        $scope.$parent.update([$attrs.ukPostcodeAddress1, $attrs.ukPostcodeAddress2, $attrs.ukPostcodeHouseName,
          $attrs.ukPostcodeHouseNumber, $attrs.ukPostcodePostTown])

      $scope.throwError = (msg) ->
        $scope.$parent["#{$attrs.ukPostcode}_message"] = msg
        $scope.$parent["#{$attrs.ukPostcode}_visible"] = true
    ]

  link: ($scope, element, attributes, ngModel) ->

    element.bind "blur", ->
      value = element.val()
      value = value && value.replace(/_/g, "")
      if value && value.length > 5
        $http
          .post("#{ConfigService.apiBaseUrl(ApplicationService.target_application_id())}/uk_postcode", q: value)
          .then(
            (response) ->
              { data } = response
              if data?[0]?.error_number? or (data && data.length is 0)
                $scope.clearFields()
                $scope.throwError(attributes.ukPostcodeErrorPostcode)
              else
                $scope.addresses = data
                $scope.open()
              response
            , -> $scope.throwError(attributes.ukPostcodeErrorPostcode)
          )

  restrict: "A"

]

# TEST POSTCODE 1: LS22 6NE ‎
# 18 Market Pl, Wetherby, Leeds, West Yorkshire
# TEST POSTCODE 2: B68 0LH
# 8 Wolverhampton Rd, Birmingham, West Midlands B68 0LH ‎
